import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/svg/dre-sad.svg?data'


const _withScopeId = n => (_pushScopeId("data-v-11826a9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-no-access-overlay__content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "app-no-access-overlay__dre",
  src: _imports_0,
  alt: "Sad dre"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "app-no-access-overlay__title" }, "Uh oh!", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "app-no-access-overlay__description" }, "Seems like you don’t have access to this page.", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Continue ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppOverlay = _resolveComponent("AppOverlay")!

  return (_openBlock(), _createBlock(_component_AppOverlay, { class: "app-no-access-overlay" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _createVNode(_component_AppButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$store.commit('teams/setShowNotATeamMemberOverlay', false)))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}